import * as React from 'react';
import * as S from './LoadingHandler.styles';
import { ProgressIndicator } from '@veneer/core';
import { primitives } from '@veneer/primitives';

export interface ILoadingHandlerProps {
  loading: boolean;
  error?: boolean | null;
  customError?: JSX.Element;
  errorTitle?: string;
  errorDescription?: string;
  loadingText?: string;
  $position?: 'absolute' | null;
  $background?: string;
  className?: string;
  children?: React.ReactNode;
}

const LoadingHandler: React.FunctionComponent<ILoadingHandlerProps> = ({
  loading,
  error,
  errorTitle,
  errorDescription,
  customError,
  children,
  className,
  loadingText,
  $position,
  $background
}) => {
  if (error) {
    return (
      customError ?? (
        <S.CenterContainer
          className={`error-container ${className}`}
          $position={$position}
          $background={$background}
        >
          <S.Text $size={3}>{errorTitle}</S.Text>
          <S.Text $size={3}>{errorDescription}</S.Text>
        </S.CenterContainer>
      )
    );
  }

  if (loading) {
    return (
      <S.CenterContainer
        className={`loading-container ${className}`}
        $position={$position}
        $background={$background}
      >
        <ProgressIndicator
          appearance="circular"
          behavior="indeterminate"
          color={primitives.color.electricBlue7}
        />
        {loadingText ? <S.Text $size={3}>{loadingText}</S.Text> : null}
      </S.CenterContainer>
    );
  }

  return <>{children}</>;
};

export default LoadingHandler;
